import React from "react";
import moment from "moment";

export default function FormattedDate({ date }) {
  if (!date || date === "") {
    // FIXME this is special purpose, refactor place where it is used to ./OurDate.jsx
    return <span>Veröffentlichung in Planung</span>;
  }

  return (
    <span>
      {moment(date, "YYYY-MM-DDTHH:mm:ss.SSSS[Z]").format("DD.MM.YYYY")}
    </span>
  );
}
